/**
 * @module Components.StripeForm
 *
 * Saved-card / new-card radio toggle, shared across the checkout flows so the
 * payment-method selector isn't reimplemented per screen. Uses a real radio
 * group (mutually-exclusive choice) for correct keyboard / screen-reader
 * semantics, with self-contained (non page-scoped) styles.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import { PaymentInfoModel } from "app/models";
import SavedPaymentMethod from "app/components/StripeForm/SavedPaymentMethod";
import styles from "./styles.module.scss";

type PropsDef = {
  paymentInfo: PaymentInfoModel;
  useSavedCard: boolean;
  onChange: () => void;
  disabled?: boolean;
};

const PaymentMethodSelector = ({ paymentInfo, useSavedCard, onChange, disabled }: PropsDef) => {
  const { t } = useTranslation();

  return (
    <div className={styles.payment_types} role="radiogroup" aria-label={t("Payment method")}>
      <label className={cls(styles.radio, useSavedCard ? styles.selected : "")}>
        <input
          type="radio"
          name="payment_method"
          className={styles.radio_input}
          checked={useSavedCard}
          onChange={onChange}
          disabled={disabled}
        />
        <SavedPaymentMethod paymentInfo={paymentInfo} className={styles.label_container} />
      </label>

      <label className={cls(styles.radio, useSavedCard ? "" : styles.selected)}>
        <input
          type="radio"
          name="payment_method"
          className={styles.radio_input}
          checked={!useSavedCard}
          onChange={onChange}
          disabled={disabled}
        />
        <div className={styles.label_container}>{t("Use a different card")}</div>
      </label>
    </div>
  );
};

export default PaymentMethodSelector;
